import React from 'react';
import NavBar from "./NavBar";

export default function NotConnectedNavBar({image_path, topbar_prop = ""}) {
    return <NavBar image_path={image_path} urls={[]} topbar_prop={topbar_prop}/>
}